/*
 *###############################################################################
 *Module Name                   : CashBookPayments.js                           #
 *Purpose of the Module         :                                               #
 *Description of the Module     :                                               #
 *Original Author               :  Isuru Sampath                                #
 *Date                          :  Wednesdays, September 12th 2024, 12:35:56 pm #
 *Copyright © 2022 myPOS Software Solution (pvt Ltd.)                           #
 *###############################################################################
 */


import React, { useEffect, useState } from "react"
import { Row, Col, Button } from "reactstrap"
import DPTextBoxforgrid from "../../../framework/components/DPTextBoxforgrid"
import ReactPaginate from "react-paginate"

const CashBookPayments = React.memo(({ DataRow, Disabled, TotalPaymentsValue, handleRowClickPayments, handleClear, PaymentsTypeData, reasonTypePaymentCode }) => {

  const [postsPerPage] = useState(10)
  const [currentPage, setCurrentPage] = useState(1)

  const [postsDetPerPage] = useState(10)
  const [currentDetPage, setCurrentDetPage] = useState(1)

  useEffect(() => {
    setCurrentPage(1)
    setCurrentDetPage(1)
  }, [handleClear])

  const handlePageClick = (event) => {
    setCurrentPage(event.selected + 1);
    console.log("Page clicked:", event.selected + 1);
  };

  const handleDetPageClick = (event) => {
    setCurrentDetPage(event.selected + 1);
    console.log("Page clicked:", event.selected + 1);
  };

  const indexOfLastPost = currentPage * postsPerPage
  const indexOfFirstPost = indexOfLastPost - postsPerPage
  const currentPosts = DataRow.slice(indexOfFirstPost, indexOfLastPost)

  const indexOfLastDetPost = currentDetPage * postsDetPerPage
  const indexOfFirstDetPost = indexOfLastDetPost - postsDetPerPage
  const currentDetPosts = PaymentsTypeData.slice(indexOfFirstDetPost, indexOfLastDetPost)


  return (
    <React.Fragment>
      <Row>
        <Col sm={12} md={12} className="mb-12-sm">
          <table
            style={{ fontSize: "12px" }}
            id={"CashBookPaymentsDet"}
          >
            <thead className="table-light-border">
              <tr>
                <th>Type</th>
                <th>Account/Reason</th>
                <th>Remark</th>
                <th>Payment Mode</th>
                <th>Description</th>
                <th style={{ textAlign: "right" }}>Amount</th>
              </tr>
            </thead>
            <tbody>
              {(currentPosts).map((row, key) => (
                <TableRow
                  key={key}
                  FormRow={row}
                  Disabled={Disabled}
                  handleRowClickPayments={handleRowClickPayments}
                />
              ))}
            </tbody>
            <tfoot>
              <tr>
                <th style={{ textAlign: "left" }}>Total Amount</th>
                <th ></th>
                <th ></th>
                <th ></th>
                <th ></th>
                <th style={{ textAlign: "right" }}>
                  <DPTextBoxforgrid
                    rowClass="mb-12-sm"
                    labelText="Code"
                    textType="text"
                    maxLength="8"
                    textAlign="right"
                    disabled={true}
                    defaultValue="0.0"
                    value={TotalPaymentsValue.toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 })}
                  ></DPTextBoxforgrid>
                </th>
              </tr>
            </tfoot>
          </table>
        </Col>
      </Row>
      <Row>
        <Col sm={6} md={6} className="mb-4-sm">
          <div className="mt-3 mb-3">
            <ReactPaginate
              previousLabel={'Previous'}
              nextLabel={'Next'}
              breakLabel={'...'}
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakClassName="page-item"
              breakLinkClassName="page-link"
              pageCount={Math.ceil(DataRow.length / postsPerPage)}
              pageRangeDisplayed={5}
              onPageChange={handlePageClick}
              forcePage={currentPage - 1}
              renderOnZeroPageCount={null}
              activeClassName={'active'}
              activeLinkClassName={'page-link'}
              containerClassName={'pagination justify-content-center pagination-sm'}
            />
          </div>
        </Col>
      </Row>
      <Col sm={12} md={12} className="mb-12-sm">
        {PaymentsTypeData.length > 0 && (
          <>
            <Row className="my-2">
              {reasonTypePaymentCode}
            </Row>
            <table style={{ fontSize: "12px" }} id={"CashBookReceiptsDet"}>
              <thead className="table-light-border">
                <tr>
                  <th>Type</th>
                  <th>Reason</th>
                  <th>Pay code</th>
                  <th>Payment Description</th>
                  <th>Detail Code</th>
                  <th>Detail Name</th>
                  <th style={{ textAlign: "right" }}>Amount</th>
                </tr>
              </thead>
              <tbody>
                {(currentDetPosts).map((row, key) => (
                  <TableDetRow
                    key={key}
                    FormRow={row}
                    Disabled={Disabled}
                  />
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <th style={{ textAlign: "left" }}>Total Amount</th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th style={{ textAlign: "right" }}>
                    <DPTextBoxforgrid
                      rowClass="mb-12-sm"
                      labelText="Code"
                      textType="text"
                      maxLength="8"
                      textAlign="right"
                      disabled={true}
                      defaultValue="0.0"
                      value={parseFloat(PaymentsTypeData.reduce((a, b) => a + (parseFloat(b.HED_TOTAMOUNT ?? 0)), 0)).toFixed(2)}
                    />
                  </th>
                </tr>
              </tfoot>
            </table>
          </>
        )}
      </Col>
      <Row>
        <Col sm={6} md={6} className="mb-4-sm">
          <div className="mt-3 mb-3">
            {PaymentsTypeData.length > 0 && (
              <ReactPaginate
                previousLabel={'Previous'}
                nextLabel={'Next'}
                breakLabel={'...'}
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                breakClassName="page-item"
                breakLinkClassName="page-link"
                pageCount={Math.ceil(DataRow.length / postsDetPerPage)}
                pageRangeDisplayed={5}
                onPageChange={handleDetPageClick}
                forcePage={currentDetPage - 1}
                renderOnZeroPageCount={null}
                activeClassName={'active'}
                activeLinkClassName={'page-link'}
                containerClassName={'pagination justify-content-center pagination-sm'}
              />
            )}
          </div>
        </Col>
      </Row>
    </React.Fragment>
  )
})

const TableRow = ({ FormRow, Key, Disabled, handleRowClickPayments }) => {

  return (
    <tr key={FormRow.id}>
      <td style={{ width: "100px" }}>

        <Col md="12">
          <Button
            className="btn-sm"
            id={"btnType" + Key}
            onClick={() => handleRowClickPayments(FormRow.type)}
            style={{ width: "100px" }}
          >
            {FormRow.type}
          </Button>
        </Col>

      </td>
      <td style={{ width: "200px" }}>
        <Col md="12">

          <DPTextBoxforgrid
            rowClass="mb-12-sm"
            labelText="Code"
            maxLength="10"
            textType="text"
            disabled={true}
            id={"txtAccount" + Key}
            value={FormRow.account}
          />
        </Col>

      </td>
      <td style={{ width: "180px" }}>

        <Col md="12">
          <DPTextBoxforgrid
            rowClass="mb-12-sm"
            labelText="Code"
            maxLength="10"
            textType="text"
            disabled={true}
            id={"txtAccount" + Key}
            value={FormRow.remark}
          />
        </Col>

      </td>
      <td style={{ width: "120px" }}>

        <Col md="12">
          <DPTextBoxforgrid
            rowClass="mb-12-sm"
            labelText="Code"
            maxLength="10"
            textType="text"
            disabled={true}
            id={"txtAccount" + Key}
            value={FormRow.paymentcode}
          />
        </Col>

      </td>
      <td style={{ width: "130px" }}>

        <Col md="12">
          <DPTextBoxforgrid
            rowClass="mb-12-sm"
            labelText="Code"
            maxLength="10"
            textType="text"
            disabled={true}
            id={"txtAccount" + Key}
            value={FormRow.paymentDescription}
          />
        </Col>

      </td>
      <td style={{ width: "100px" }}>

        <Col md="12">
          <DPTextBoxforgrid
            rowClass="mb-12-sm"
            labelText="Code"
            maxLength="10"
            defaultValue="0.0"
            textAlign="right"
            id={"txtAmount" + Key}
            value={parseFloat(FormRow.amount ?? 0).toFixed(2)}
            disabled={Disabled}
          />
        </Col>

      </td>
    </tr>
  );
};

const TableDetRow = ({ FormRow, Key, Disabled }) => {

  return (
    <tr key={FormRow.id}>
      <td style={{ width: "100px" }}>

        <Col md="12">
          <DPTextBoxforgrid
            rowClass="mb-12-sm"
            labelText="Code"
            maxLength="10"
            textType="text"
            disabled={true}
            id={"txtPaymentDescription" + Key}
            value={FormRow.RC_CODE}
          />
        </Col>

      </td>
      <td style={{ width: "200px" }}>
        <Col md="12">

          <DPTextBoxforgrid
            rowClass="mb-12-sm"
            labelText="Code"
            maxLength="10"
            textType="text"
            disabled={true}
            id={"txtAccount" + Key}
            value={FormRow.RC_DESC}
          ></DPTextBoxforgrid>
        </Col>

      </td>

      <td style={{ width: "100px" }}>

        <Col md="12">
          <DPTextBoxforgrid
            rowClass="mb-12-sm"
            labelText="Code"
            maxLength="10"
            textType="text"
            disabled={true}
            id={"txtPaymentDescription" + Key}
            value={FormRow.PAYDET_PHCODE}
          />
        </Col>

      </td>

      <td style={{ width: "200px" }}>
        <Col md="12">

          <DPTextBoxforgrid
            rowClass="mb-12-sm"
            labelText="Code"
            maxLength="10"
            textType="text"
            disabled={true}
            id={"txtAccount" + Key}
            value={FormRow.PY_DESC}
          ></DPTextBoxforgrid>
        </Col>

      </td>

      <td style={{ width: "100px" }}>
        <Col md="12">

          <DPTextBoxforgrid
            rowClass="mb-12-sm"
            labelText="Code"
            maxLength="10"
            textType="text"
            disabled={true}
            id={"txtAccount" + Key}
            value={FormRow.PAYDET_PDCODE}
          ></DPTextBoxforgrid>
        </Col>

      </td>

      <td style={{ width: "200px" }}>
        <Col md="12">

          <DPTextBoxforgrid
            rowClass="mb-12-sm"
            labelText="Code"
            maxLength="10"
            textType="text"
            disabled={true}
            id={"txtAccount" + Key}
            value={FormRow.PH_DESC}
          ></DPTextBoxforgrid>
        </Col>

      </td>

      <td style={{ width: "100px" }}>

        <Col md="12">
          <DPTextBoxforgrid
            rowClass="mb-12-sm"
            labelText="Code"
            maxLength="10"
            defaultValue="0.0"
            textAlign="right"
            id={"txtAmount" + Key}
            value={parseFloat(FormRow.HED_TOTAMOUNT ?? 0).toFixed(2)}
            disabled={Disabled}
          />
        </Col>

      </td>
    </tr>
  );
};

export default CashBookPayments